import { render, staticRenderFns } from "./RegionsIndex.vue?vue&type=template&id=f30426c4"
import script from "./RegionsIndex.vue?vue&type=script&lang=js"
export * from "./RegionsIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports